import myApi from '@/util/api'

export function getFolders() {

  return myApi.getAll('Folders/GetFolders')
}
export function getSubFolders() {

  return myApi.getAll('Folders/GetSubFolders')
}
export function getFolderTypes() {

  return myApi.getAll('Folders/GetCodeMaster')
}
export function getSubFoldersId(id, userId) {

  return myApi.getByuserId(id, userId, 'Folders/GetSubFoldersId')
}
export function getFolderTreeId(id, userId) {

  return myApi.getByuserId(id, userId, 'Folders/GetSubNestedFoldersId')
}
// export function getSubFolderId(id, userId) {

//   return myApi.getByuserId(id, userId, 'Folders/GetSubFolderId')
// }
// export function getSubNestedFoldersId(id) {

//   return myApi.getByID(id, 'Folders/GetSubNestedFoldersId')
// }
export function getFolder(data) {

  return myApi.getItem(data, "Folders/GetData")
}

export function createFolders(data) {
  return myApi.create(data, "Folders/InsertFolders")
}

export function updateFolders(data) {

  return myApi.update(data.foldersID, data, "Folders/UpdateFolders")
}
export function createSubFolder(data) {
  console.log(data);
  return myApi.create(data, "Folders/InsertSubFolder")
}

export function updateSubFolder(data) {

  return myApi.update(data.foldersID, data, "Folders/UpdateSubFolder")
}
export function deleteFolders(data) {

  return myApi.delete(data.foldersID, 'Folders/DeleteFolders')
}
export function getFolderFiles(id) {

  return myApi.getByID(id, 'Folders/GetFolderFiles')
}


// WEBPACK FOOTER //
// ./src/api/folder.js